
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: {
    classDiv: String,
    NAME: String,
    counts: Array,
    click: Function,
    id: String,
  },
})
export default class TabsEvent extends Vue {
  mounted() {
    $(document).ready(function () {
      $(".tabs").tabs();
    });
  }
  changeMessage() {}
}
